/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsRecordingTitle
 */
export interface RecordingManualChangesResponseFieldsRecordingTitle {
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsRecordingTitle
     */
    op: string;
    /**
     * 
     * @type {object}
     * @memberof RecordingManualChangesResponseFieldsRecordingTitle
     */
    value: object | null;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsRecordingTitle
     */
    note?: string;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsRecordingTitle interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsRecordingTitle(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json: any): RecordingManualChangesResponseFieldsRecordingTitle {
    return RecordingManualChangesResponseFieldsRecordingTitleFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsRecordingTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsRecordingTitle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'value': json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function RecordingManualChangesResponseFieldsRecordingTitleToJSON(value?: RecordingManualChangesResponseFieldsRecordingTitle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'value': value.value,
        'note': value.note,
    };
}

